import { useField, useFormikContext } from 'formik';

/**
 * Returns the Yup error for a field only after the user has touched it OR
 * attempted a submit.
 *
 * Why the dual gate: formik's submit-time auto-touch only flows to keys
 * present in `formik.values`, so fields not seeded into `defaultValues`
 * (e.g. cost / schedule / priority / discipline / category) would otherwise
 * never display their "This field is required." error after submit. Gating
 * on `submitCount > 0` as the secondary signal surfaces the error without
 * needing every field component to seed itself into `defaultValues`.
 */
export const useFormikFieldErrorAfterSubmit = (fieldName: string): string | undefined => {
  const [, meta] = useField(fieldName);
  const { submitCount } = useFormikContext();
  return meta.touched || submitCount > 0 ? meta.error : undefined;
};
